/*!
 * Bombka Wspomnień – cart drawer (Shopify Ajax Cart API)
 * Uses /cart.js, /cart/change.js and /cart/update.js.
 * The discount code is passed to checkout with Shopify's supported
 * "/checkout?discount=CODE" parameter only while the offer is active.
 */
(function () {
  'use strict';

  var BW = window.BW || {};
  var R = BW.routes || {};
  var S = BW.strings || {};
  var html = document.documentElement;

  var drawer, panel, list, empty, foot, subtotal, countLabel, errorBox;
  var cart = null;
  var lastFocus = null;
  var busy = false;

  /* ---------- helpers ---------- */
  function esc(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = parseInt(cents, 10) || 0;
    format = format || BW.moneyFormat || '{{amount_with_comma_separator}} zł';
    var re = /\{\{\s*(\w+)\s*\}\}/;
    function withDelims(number, precision, thousands, decimal) {
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      var n = (number / 100).toFixed(precision);
      var parts = n.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
      return parts[1] ? whole + decimal + parts[1] : whole;
    }
    var match = format.match(re);
    var key = match ? match[1] : 'amount';
    var value;
    switch (key) {
      case 'amount': value = withDelims(cents, 2); break;
      case 'amount_no_decimals': value = withDelims(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelims(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelims(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = withDelims(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = withDelims(cents, 0, ' ', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelims(cents, 2, "'", '.'); break;
      default: value = withDelims(cents, 2, ' ', ',');
    }
    return format.replace(re, value);
  }

  function offerActive() {
    return !!(BW.offer && BW.offer.enabled) && html.classList.contains('bw-offer-active');
  }

  function checkoutUrl() {
    var base = R.checkout || '/checkout';
    if (BW.offer && BW.offer.autoApply && offerActive() && BW.offer.code) {
      return base + '?discount=' + encodeURIComponent(BW.offer.code);
    }
    return base;
  }

  function pluralCount(n) {
    var key;
    var mod10 = n % 10, mod100 = n % 100;
    if (n === 1) key = S.cartCountOne;
    else if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) key = S.cartCountFew;
    else key = S.cartCountMany;
    return (key || '__N__').replace('__N__', n);
  }

  function sizedImage(url, width) {
    if (!url) return '';
    try {
      var u = new URL(url, window.location.origin);
      u.searchParams.set('width', width);
      return u.toString();
    } catch (e) { return url; }
  }

  function jsonFetch(url, opts) {
    opts = opts || {};
    opts.headers = Object.assign({ 'Accept': 'application/json' }, opts.headers || {});
    opts.credentials = 'same-origin';
    return fetch(url, opts).then(function (res) {
      return res.json().catch(function () { return {}; }).then(function (data) {
        if (!res.ok) {
          var err = new Error(data.description || data.message || 'error');
          err.status = res.status; err.data = data;
          throw err;
        }
        return data;
      });
    });
  }

  /* ---------- rendering ---------- */
  function updateCount(count) {
    var nodes = document.querySelectorAll('[data-bw-cart-count]');
    for (var i = 0; i < nodes.length; i++) {
      nodes[i].textContent = count;
      nodes[i].hidden = count === 0;
      nodes[i].classList.remove('is-bump');
      void nodes[i].offsetWidth;
      nodes[i].classList.add('is-bump');
    }
    var srs = document.querySelectorAll('[data-bw-cart-count-sr]');
    for (var j = 0; j < srs.length; j++) srs[j].textContent = pluralCount(count);
    if (countLabel) countLabel.textContent = count ? '(' + pluralCount(count) + ')' : '';
  }

  function itemHTML(item, index) {
    var img = item.image ? '<img src="' + esc(sizedImage(item.image, 220)) + '" alt="' + esc(item.product_title) + '" width="110" height="110" loading="lazy">' : '<span class="bw-ci__noimg"></span>';
    var variant = item.product_has_only_default_variant ? '' : '<p class="bw-ci__variant">' + esc(item.variant_title || '') + '</p>';
    var props = '';
    if (item.properties) {
      Object.keys(item.properties).forEach(function (k) {
        var v = item.properties[k];
        if (v && k.charAt(0) !== '_') props += '<p class="bw-ci__variant">' + esc(k) + ': ' + esc(v) + '</p>';
      });
    }
    var compare = item.original_line_price > item.final_line_price
      ? '<s>' + formatMoney(item.original_line_price) + '</s>' : '';
    return '' +
      '<li class="bw-ci" style="--i:' + index + '" data-key="' + esc(item.key) + '">' +
        '<a class="bw-ci__media" href="' + esc(item.url) + '">' + img + '<span class="bw-ci__glint" aria-hidden="true"></span></a>' +
        '<div class="bw-ci__info">' +
          '<a class="bw-ci__title" href="' + esc(item.url) + '">' + esc(item.product_title) + '</a>' +
          variant + props +
          '<div class="bw-ci__row">' +
            '<div class="bw-qty bw-qty--sm" role="group" aria-label="' + esc(S.cartQuantity) + '">' +
              '<button type="button" class="bw-qty__btn" data-bw-ci-qty="' + (item.quantity - 1) + '" aria-label="' + esc(S.cartQtyDecrease) + '">−</button>' +
              '<span class="bw-qty__value" aria-live="polite">' + item.quantity + '</span>' +
              '<button type="button" class="bw-qty__btn" data-bw-ci-qty="' + (item.quantity + 1) + '" aria-label="' + esc(S.cartQtyIncrease) + '">+</button>' +
            '</div>' +
            '<p class="bw-ci__price">' + compare + '<span>' + formatMoney(item.final_line_price) + '</span></p>' +
          '</div>' +
          '<button type="button" class="bw-ci__remove" data-bw-ci-qty="0">' + esc(S.cartRemove) + '</button>' +
        '</div>' +
      '</li>';
  }

  function render() {
    if (!drawer || !cart) return;
    var count = cart.item_count || 0;
    updateCount(count);
    if (!count) {
      list.innerHTML = '';
      empty.hidden = false;
      foot.hidden = true;
      return;
    }
    empty.hidden = true;
    foot.hidden = false;
    list.innerHTML = cart.items.map(itemHTML).join('');
    subtotal.textContent = formatMoney(cart.total_price);
  }

  function showError(msg) {
    if (!errorBox) return;
    errorBox.textContent = msg || '';
    errorBox.hidden = !msg;
  }

  /* ---------- API ---------- */
  function refresh() {
    return jsonFetch((R.cart || '/cart') + '.js').then(function (data) {
      cart = data;
      render();
      return data;
    });
  }

  function change(key, qty) {
    if (busy) return Promise.resolve();
    busy = true;
    drawer.classList.add('is-busy');
    showError('');
    return jsonFetch((R.cartChange || '/cart/change') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: Math.max(0, qty) })
    }).then(function (data) {
      cart = data;
      render();
    }).catch(function (err) {
      showError(err.status === 422 ? (S.stockError || S.cartError) : S.cartError);
    }).then(function () {
      busy = false;
      drawer.classList.remove('is-busy');
    });
  }

  /* ---------- open / close ---------- */
  function lockScroll(lock) {
    document.body.classList.toggle('bw-locked', lock);
  }

  function open() {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.hidden = false;
    lockScroll(true);
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        drawer.classList.add('is-open');
        panel.focus({ preventScroll: true });
      });
    });
  }

  function close() {
    if (!drawer || drawer.hidden) return;
    drawer.classList.remove('is-open');
    lockScroll(false);
    var done = function () {
      if (!drawer.classList.contains('is-open')) drawer.hidden = true;
    };
    var reduce = html.classList.contains('bw-tier-reduced');
    setTimeout(done, reduce ? 10 : 520);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  function trapFocus(e) {
    if (e.key !== 'Tab' || !drawer.classList.contains('is-open')) return;
    var f = panel.querySelectorAll('a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])');
    var visible = Array.prototype.filter.call(f, function (el) { return el.offsetParent !== null; });
    if (!visible.length) return;
    var first = visible[0], last = visible[visible.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  function goCheckout(btn) {
    if (btn) btn.classList.add('is-loading');
    window.location.href = checkoutUrl();
  }

  /* ---------- init ---------- */
  function init() {
    drawer = document.querySelector('[data-bw-drawer]');
    if (drawer) {
      panel = drawer.querySelector('[role="dialog"]');
      list = drawer.querySelector('[data-bw-cart-items]');
      empty = drawer.querySelector('[data-bw-cart-empty]');
      foot = drawer.querySelector('[data-bw-cart-foot]');
      subtotal = drawer.querySelector('[data-bw-cart-subtotal]');
      countLabel = drawer.querySelector('[data-bw-cart-count-label]');
      errorBox = drawer.querySelector('[data-bw-cart-error]');

      drawer.addEventListener('click', function (e) {
        var q = e.target.closest('[data-bw-ci-qty]');
        if (q) {
          var li = q.closest('[data-key]');
          if (li) change(li.getAttribute('data-key'), parseInt(q.getAttribute('data-bw-ci-qty'), 10));
          return;
        }
        if (e.target.closest('[data-bw-cart-close]')) close();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') close();
        trapFocus(e);
      });
    }

    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-bw-cart-open]');
      if (opener && drawer && !document.body.classList.contains('template-cart')) {
        e.preventDefault();
        open();
        refresh().catch(function () { showError(S.cartError); });
        return;
      }
      var co = e.target.closest('[data-bw-checkout]');
      if (co) {
        e.preventDefault();
        goCheckout(co);
      }
    });

    // Cart page (/cart): keep quantity updates, then go to checkout with the code.
    var cartForm = document.querySelector('[data-bw-cart-form]');
    if (cartForm) {
      var lastSubmitter = null;
      cartForm.addEventListener('click', function (e) {
        var b = e.target.closest('button[type="submit"]');
        if (b) lastSubmitter = b;
      });
      cartForm.addEventListener('submit', function (e) {
        var submitter = e.submitter || lastSubmitter;
        if (!submitter || submitter.name !== 'checkout') return;
        e.preventDefault();
        submitter.classList.add('is-loading');
        fetch((R.cartUpdate || '/cart/update') + '.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Accept': 'application/json' },
          body: new FormData(cartForm)
        }).then(function () {
          window.location.href = checkoutUrl();
        }).catch(function () {
          window.location.href = checkoutUrl();
        });
      });
    }
  }

  window.BWCart = {
    open: open,
    close: close,
    refresh: refresh,
    checkoutUrl: checkoutUrl,
    formatMoney: formatMoney,
    updateCount: updateCount
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
